import { Component, Inject, ViewChild } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';

import { AddEditSavedSearchDialogData } from '../../models/add-edit-saved-search-dialog-data';
import { SavedSearchFormComponent } from '../saved-search-form/saved-search-form.component';
import { SavedSearchStoreService } from '@saved-search/store/services/saved-search-store.service';
import { SavedSearchData } from '../../models/saved-search-data';
import { FoldersStoreReadService } from '@folders/store/services/folders-store-read.service';
import { RpcButtonComponent } from '../../../core-modules/controls/components/rpc-button/rpc-button.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'add-edit-saved-search-dialog',
    templateUrl: './add-edit-saved-search-dialog.component.html',
    styleUrls: ['./add-edit-saved-search-dialog.component.scss'],
    imports: [RpcButtonComponent, SavedSearchFormComponent, AsyncPipe, TranslateModule]
})
export class AddEditSavedSearchDialogComponent {
    @ViewChild(SavedSearchFormComponent) private readonly savedSearchFormComponent: SavedSearchFormComponent;

    public readonly folders$ = this.foldersStoreReadService.customFoldersSortedByDate$;

    constructor(
        private readonly dialogRef: DialogRef<unknown, AddEditSavedSearchDialogComponent>,
        @Inject(DIALOG_DATA) public readonly data: AddEditSavedSearchDialogData,
        private readonly savedSearchStoreService: SavedSearchStoreService,
        private readonly foldersStoreReadService: FoldersStoreReadService,
    ) { }

    public get isFormInvalid(): boolean {
        return this.savedSearchFormComponent?.form?.invalid;
    }

    public onDeleteSavedSearch(): void {
        this.savedSearchStoreService.showDeleteSavedSearchDialog(this.data.savedSearch, () => this.onClose());
    }

    public onClose(): void {
        this.dialogRef.close();
    }

    public onSave(): void {
        const formValue = this.savedSearchFormComponent.getFormValue();
        const value: SavedSearchData = { ...formValue, isCreation: false };

        this.dialogRef.close(value);
    }
}